var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"form",staticClass:"form-input",attrs:{"model":_vm.form}},[_c('el-form-item',{staticClass:"item",attrs:{"label":_vm.$attrs.name,"prop":"newValue"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }